module.exports = __webpack_public_path__ + "static/img/logo.8b51f806.svg";